// ── FEATURED ON / AS SEEN ON STRIP ──────────────────────────────
// Social proof strip. To show a listing: set enabled: true and paste
// your project's page URL on that site. Section stays hidden until at
// least one entry is enabled — so nothing false ever shows.
const listings = [
  { name: "ICODrops", enabled: false, href: "" },
  { name: "CoinMarketCap", enabled: false, href: "" },
  { name: "CryptoRank", enabled: false, href: "" },
  { name: "CoinGecko", enabled: false, href: "" },
  { name: "PinkSale", enabled: true, href: "https://www.pinksale.finance/launchpad/base/0x15e3214aD1DB6B36aA189933E838Eb39b643A1a6" },
];
// ─────────────────────────────────────────────────────────────────

export default function FeaturedOn() {
  const active = listings.filter((l) => l.enabled);
  if (active.length === 0) return null;

  return (
    <section
      data-testid="featured-on"
      className="border-y border-white/10 bg-card/30 py-10 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <p className="text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
          Featured On
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
          {active.map((l) => (
            <a
              key={l.name}
              href={l.href || "#"}
              target={l.href ? "_blank" : undefined}
              rel={l.href ? "noreferrer" : undefined}
              data-testid={`featured-${l.name.toLowerCase()}`}
              className="font-display font-bold text-xl sm:text-2xl text-muted-foreground/70 grayscale hover:grayscale-0 hover:text-foreground transition-all"
            >
              {l.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
